import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import Delete from '@material-ui/icons/Delete';

import { deleteMappingItem } from '../../../store/actions/metadata.actions';

const styles = theme => ({
  listItem: {
    '&:hover': {
      background: theme.palette.grey[200],
    },
  },

  header: {
    minWidth: '150px',
  },

  mapping: {
    paddingLeft: '25px',
  },

  icon: {
    marginRight: '30px',
    float: 'right',
    cursor: 'pointer',
    color: theme.palette.grey[500],

    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
});

const MappingListItemComponent = ({
  classes,
  column,
  deleteMappingItem, // eslint-disable-line no-shadow
}) => {
  const handleDelete = id => deleteMappingItem(id);

  if (!column.mapped) return null;

  return (
    <React.Fragment>
      <ListItem className={classes.listItem}>
        <Delete
          onClick={() => { handleDelete(column.key); }}
          className={classes.icon}
        />
        <Typography className={classes.header}>{column.key}</Typography>
        <Icon>arrow_right_alt</Icon>
        <Typography className={classes.mapping}>{column.name}</Typography>
      </ListItem>
      <Divider />
    </React.Fragment>
  );
};

MappingListItemComponent.propTypes = {
  column: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    mapped: PropTypes.bool,
  }).isRequired,
  deleteMappingItem: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(
  styles,
  { withTheme: true },
)(connect(
  null,
  { deleteMappingItem },
)(MappingListItemComponent));
